import React from 'react';

const Status = ({ rowData }) => {
    return (
        <span>
            {rowData.status === "p" ? "پرداخت شده" : "پرداخت نشده"}
        </span>
    );
}

export default Status;
